import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  gap: 0.3rem 0.5rem;
  flex-wrap: wrap;
  z-index: 1;
  height: 100%;
`;
